const FOCUSABLE = "input:not([type=\"hidden\"]), textarea, [role=\"combobox\"], button";

export default function focusField(name) {
  const field = document.querySelector(`[data-field="${name}"]`);
  if (!field) return;
  const target = field.matches(FOCUSABLE) ? field : field.querySelector(FOCUSABLE) || field;
  if (target) target.focus();
}
